import { z } from 'zod';
import { shiftListRowSchema } from './shiftCommonSchema';
const getOngoingShiftsByMissionIdRequestSchema = z.object({
    missionId: z.string().uuid(),
    limit: z.number().optional(),
    offset: z.number().optional(),
});
const getOngoingShiftsByMissionIdResponseSchema = z.object({
    rows: shiftListRowSchema.array(),
    total: z.number(),
});
export const getOngoingShiftsByMissionIdFunctionDef = {
    name: 'getOngoingShiftsByMissionId',
    requestSchema: getOngoingShiftsByMissionIdRequestSchema,
    responseSchema: getOngoingShiftsByMissionIdResponseSchema,
};
